<template>
  <div class="add_test__step-1" v-if="parent_user">
    <!-- tab 1 content -->
    <div class="vx-row" id="add_test__step-1">
      <!-- Bussiness Name -->
      <div class="vx-col md:w-1/2 w-full mt-3">
        <vs-input
          label="Bussiness Name"
          :value="parent_user.business_name"
          @change="(e) => setState({ action: 'parent_user.business_name', data: e.target.value })"
          class="w-full"
          data-vv-validate-on="blur"
          v-validate="'required'"
          name="Bussiness Name"
        />
        <span class="text-danger text-sm" v-show="errors.has('Bussiness Name')">{{ errors.first('Bussiness Name') }}</span>
      </div>

      <!-- Omma License Number -->
      <div class="vx-col md:w-1/2 w-full mt-3">
        <vs-input
          label="OMMA License Number"
          :value="parent_user.omma_license_number"
          @change="(e) => setState({ action: 'parent_user.omma_license_number', data: e.target.value })"
          class="w-full"
          data-vv-validate-on="blur"
          v-validate="'required'"
          name="OMMA License Number"
        />
        <span class="text-danger text-sm" v-show="errors.has('OMMA License Number')">{{ errors.first('OMMA License Number') }}</span>
      </div>

      <!-- First Name -->
      <div class="vx-col md:w-1/2 w-full mt-3">
        <vs-input
          label="First Name"
          :value="parent_user.firstname"
          @change="(e) => setState({ action: 'parent_user.firstname', data: e.target.value })"
          class="w-full"
          data-vv-validate-on="blur"
          v-validate="'required'"
          name="Firstname"
        />
        <span class="text-danger text-sm" v-show="errors.has('Firstname')">{{ errors.first('Firstname') }}</span>
      </div>

      <!-- Last Name -->
      <div class="vx-col md:w-1/2 w-full mt-3">
        <vs-input
          label="Last Name"
          :value="parent_user.lastname"
          @change="(e) => setState({ action: 'parent_user.lastname', data: e.target.value })"
          class="w-full"
          data-vv-validate-on="blur"
          v-validate="'required'"
          name="Lastname"
        />
        <span class="text-danger text-sm" v-show="errors.has('Lastname')">{{ errors.first('Lastname') }}</span>
      </div>

      <!-- Phone Number -->
      <div class="vx-col md:w-1/2 w-full mt-3">
        <vs-input
          label="Phone"
          :value="parent_user.mobile"
          @change="(e) => setState({ action: 'parent_user.mobile', data: e.target.value })"
          class="w-full"
          data-vv-validate-on="blur"
          v-validate="'required'"
          name="Phone"
        />
        <span class="text-danger text-sm" v-show="errors.has('Phone')">{{ errors.first('Phone') }}</span>
      </div>

      <!-- Email -->
      <div class="vx-col md:w-1/2 w-full mt-3">
        <vs-input
          type="email"
          :value="parent_user.email"
          @change="(e) => setState({ action: 'parent_user.email', data: e.target.value })"
          label="Email"
          class="w-full"
          data-vv-validate-on="blur"
          v-validate="'required'"
          name="Email"
        />
        <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
      </div>

      <!-- Address -->
      <div class="vx-col md:w-1/2 w-full mt-3">
        <vs-input
          label="Address"
          :value="parent_user.address"
          @change="(e) => setState({ action: 'parent_user.address', data: e.target.value })"
          class="w-full"
          data-vv-validate-on="blur"
          v-validate="'required'"
          name="Address"
        />
        <span class="text-danger text-sm" v-show="errors.has('Address')">{{ errors.first('Address') }}</span>
      </div>

      <!-- City -->
      <div class="vx-col md:w-1/2 w-full mt-3">
        <label for="">City</label>
        <select-2
          :ssr="false"
          class="w-full"
          :value="parent_user.cityId"
          @input="(e) => setState({ action: 'parent_user.cityId', data: e })"
          placeholder="Please Select City"
          :options="citiesOptions"
          data-vv-validate-on="blur"
          v-validate="'required'"
          name="City"
        />
        <span class="text-danger text-sm" v-show="errors.has('City')">{{ errors.first('City') }}</span>
      </div>

      <!-- State -->
      <div class="vx-col md:w-1/2 w-full mt-3">
        <vs-input
          label="State"
          :value="parent_user.state"
          @change="(e) => setState({ action: 'parent_user.state', data: e.target.value })"
          class="w-full"
          data-vv-validate-on="blur"
          v-validate="'required'"
          name="State"
        />
        <span class="text-danger text-sm" v-show="errors.has('State')">{{ errors.first('State') }}</span>
      </div>

      <!-- Zip Code -->
      <div class="vx-col md:w-1/2 w-full mt-3">
        <vs-input
          label="Zip Code"
          :value="parent_user.zipcode"
          @change="(e) => setState({ action: 'parent_user.zipcode', data: e.target.value })"
          class="w-full"
          data-vv-validate-on="blur"
          v-validate="'required'"
          name="Zipcode"
        />
        <span class="text-danger text-sm" v-show="errors.has('Zipcode')">{{ errors.first('Zipcode') }}</span>
      </div>

      <!-- Batch No. -->
      <div class="vx-col md:w-1/2 w-full mt-3">
        <label for="">Batch</label>
        <select-2
          autocomplete
          class="w-full"
          :value="step1.batch"
          @input="(e) => $emit('update:step1', { ...step1, batch: e.value })"
          name="Batch"
          placeholder="Please Select Batch"
          :loading="batchLoader"
          :options="batchOptions"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Batch')">{{ errors.first('Batch') }}</span>
      </div>

      <!-- Product Name -->
      <div class="vx-col md:w-1/2 w-full mt-3">
        <vs-input label="Product Name" class="w-full" v-model="step1.product_name" data-vv-validate-on="blur" v-validate="'required'" name="Product Name" />
        <span class="text-danger text-sm" v-show="errors.has('Product Name')">{{ errors.first('Product Name') }}</span>
      </div>

      <!-- Category -->
      <div class="vx-col md:w-1/2 w-full mt-3">
        <label for="">Category</label>
        <select-2
          autocomplete
          class="w-full"
          :value="step1.category"
          @input="(e) => $emit('update:step1', { ...step1, category: e.value })"
          name="Category"
          placeholder="Please Select Category"
          :loading="categoryLoader"
          :options="categoryOptions"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Category')">{{ errors.first('Category') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { DEMORETAILER } from '@/utils/roles.js'

export default {
  name: 'AddTestStep1',
  components: {
    Select2
  },
  props: {
    step1: {
      batch: Number,
      category: Number,
      product_name: String
    }
  },

  data() {
    return {
      citiesOptions: [],
      is_global: 'global',
      DEMORETAILER,
      loading: false,
      batchLoader: false,
      categoryLoader: false
    }
  },

  async mounted() {
    await this.get_cities_options() // get city options
    await this.get_batch_options() // get batch options
    await this.get_product_categories() // get product category options
  },

  methods: {
    ...mapMutations('lab_test', { setState: 'SET_STATE' }),
    ...mapActions({ fetch_city_options: 'getCityOptions' }),
    ...mapActions('batch', { fetch_batch_options: 'getBatches' }),
    ...mapActions('product', { fetch_product_categories: 'getProductCategories' }),

    // get city options
    async get_cities_options() {
      try {
        const { data } = await this.fetch_city_options({ search: '' })
        this.citiesOptions = data
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // get batch options
    async get_batch_options() {
      this.batchLoader = true
      try {
        const payload = {
          search: '',
          page: 1,
          limit: 0
        }

        await this.fetch_batch_options(payload)
        this.batchLoader = false
      } catch ({ message }) {
        this.batchLoader = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // get product categories
    async get_product_categories() {
      this.categoryLoader = true
      const { is_global } = this
      try {
        const payload = {
          search: '',
          page: 1,
          limit: 0,
          order: ['id', 'ASC'],
          is_global: this.user.roleId === DEMORETAILER ? null : is_global,
          is_status: true
        }
        await this.fetch_product_categories(payload)
        this.categoryLoader = false
      } catch ({ message }) {
        this.categoryLoader = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },

  computed: {
    ...mapState('lab_test', ['parent_user']),
    ...mapState('batch', ['batches']),
    ...mapState('product', { productCategories: 'product-categories' }),
    ...mapState('auth', ['user']),

    batchOptions() {
      return this.batches.reduce((acc, item) => {
        item.value = item.id
        item.label = `${item.batch_number} ( ${item.batch_name || '-'} )`

        acc.push(item)

        return acc
      }, [])
    },

    categoryOptions() {
      return this.productCategories.reduce((acc, item) => {
        item.value = item.id
        item.label = item.category_name

        acc.push(item)

        return acc
      }, [])
    }
  },
  watch: {
    // set loading
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#add_test__step-1',
          scale: 0.45,
          color: 'primary'
        })
      } else {
        this.$vs.loading.close('#add_test__step-1 > .con-vs-loading')
      }
    }
  }
}
</script>

<style></style>
